'use strict';

import Swiper from 'swiper';

export default class SliderQuotes {
    constructor() {
        document.querySelectorAll('.flx_slider_quotes .swiper').forEach((el) => {
            const pagination = el.querySelector('.swiper-pagination');
            const wrapper = el.querySelector('.swiper-wrapper');

            const setMaxHeight = () => {
                if (!wrapper) return;
                wrapper.style.minHeight = '';
                let max = 0;
                wrapper.querySelectorAll('.swiper-slide').forEach((s) => {
                    max = Math.max(max, s.offsetHeight);
                });
                wrapper.style.minHeight = max + 'px';
            };

            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 600,
                loop: true,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                } : false,
                on: {
                    init: setMaxHeight,
                    imagesReady: setMaxHeight,
                    resize: setMaxHeight,
                },
            });
        });
    }
}
